export default function CourseDraftPreview({ structure, error }) {
  // This stateless preview allows duplicate names and new entries without IDs; positions identify occurrences.
  return <section className="course-editor__preview" aria-label="Course structure preview">
    <h2>Structure preview</h2>
    {error ? <p><output>{error} You can still save this draft.</output></p> : <>
      {structure.units.length === 0 && <p>Add a unit with # and a page with ##.</p>}
      {structure.units.map((unit, index) => <section key={index}>
        <h3>{unit.name}</h3>
        <ul>{unit.pages.map((page, pageIndex) => <li key={pageIndex}>{page.name} {page.id ? '(existing page)' : '(new blank page)'}</li>)}</ul>
      </section>)}
    </>}
  </section>;
}
